import { Injectable } from '@angular/core';
import { SnackbarService } from '@fantaz/core/utils';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

import { environment } from '@fantaz/shared/app-config';
import * as SnackbarActions from './snackbar.actions';

@Injectable()
export class CoreSnackbarEffects {
  showSnackbar$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SnackbarActions.showSnackbar),
        tap(({ message, config }) => {
          this.snackbarService.showSnackbar(message, config);
        }),
      ),
    { dispatch: false },
  );

  showSnackbarError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SnackbarActions.showSnackbarError),
        tap(({ message, config }) => {
          if (!environment.production) {
            console.group('CoreErrorTrackEffects');
            console.info('message', message);
            console.info('config', config);
            console.groupEnd();
          }
          this.snackbarService.showSnackbarError(message, config);
        }),
      ),
    { dispatch: false },
  );

  showSnackbarSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SnackbarActions.showSnackbarSuccess),
        tap(({ message, config }) => {
          this.snackbarService.showSnackbarSuccess(message, config);
        }),
      ),
    { dispatch: false },
  );

  showSnackbarWarning$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SnackbarActions.showSnackbarWarning),
        tap(({ message, config }) => {
          this.snackbarService.showSnackbarWarning(message, config);
        }),
      ),
    { dispatch: false },
  );

  showSnackbarInfo$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SnackbarActions.showSnackbarInfo),
        tap(({ message, config }) => {
          this.snackbarService.showSnackbarInfo(message, config);
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private readonly actions$: Actions,
    private readonly snackbarService: SnackbarService,
  ) {}
}
